import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20atmospheric%20manga%20scene%20with%20mysterious%20shadowy%20figure%20in%20foggy%20alleyway%2C%20warm%20orange%20and%20deep%20black%20color%20palette%2C%20dramatic%20cinematic%20lighting%20with%20god%20rays%2C%20urban%20night%20setting%20with%20neon%20signs%2C%20horizontal%20composition%2C%20no%20text%2C%20atmospheric%20thriller%20mood%2C%20professional%20illustration%20style&width=1920&height=1080&seq=hero-bg-manga&orientation=landscape"
        alt="叮当漫画网 - 全球诡异时代"
        title="全球诡异时代漫画 - 叮当漫画网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-3xl">
            <span className="inline-block px-3 py-1 bg-primary-500/90 text-background-50 dark:text-foreground-950 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
              全网热播 · 无删减版
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 leading-tight">
              全球诡异时代
            </h1>
            <p className="mt-4 text-foreground-300 text-sm md:text-base max-w-xl leading-relaxed">
              一场突如其来的全球诡异事件席卷世界，普通高中生林夜在诡异降临后觉醒了特殊能力。下拉式免费阅读，所有章节完整呈现。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <Link
                to="/article/1"
                className="inline-flex items-center justify-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                立即阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/category"
                className="inline-flex items-center justify-center gap-2 px-7 py-3 bg-background-100/80 hover:bg-background-200/80 text-foreground-100 font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                浏览全部漫画
                <i className="ri-apps-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}